import React from 'react';
import PropTypes from 'prop-types';

import useRandomId from 'hooks/useRandomId';
import LabeledFieldWrapper from '../LabeledFieldWrapper';

const LabeledTextarea = React.forwardRef(
  (
    {
      backgroundColor = 'white',
      errorMessage,
      id: customInputId,
      label,
      onChange,
      placeholder,
      resizable,
      value,
      ...rest
    },
    ref
  ) => {
    const randomInputId = useRandomId('LabeledTextarea__input');
    const id = customInputId || randomInputId;

    return (
      <LabeledFieldWrapper
        backgroundColor={backgroundColor}
        errorMessage={errorMessage}
        hasValue={!!value}
        inputId={id}
        label={label}
        hasPlaceholder={!!placeholder}
        placeholder={placeholder}
      >
        <textarea
          {...rest}
          aria-describedby={`${id}-error`}
          aria-invalid={!!errorMessage || undefined}
          className="bg-transparent border-0 text-[inherit] [font-weight:inherit] leading-[inherit] tracking-[inherit] min-h-[77px] resize-none w-full focus:outline-0 [&::-webkit-resizer]:border-t-transparent [&::-webkit-resizer]:border-l-transparent [&::-webkit-resizer]:border-b-brand-darker [&::-webkit-resizer]:border-r-brand-darker [&::-webkit-resizer]:border-solid [&::-webkit-resizer]:border-[16px]"
          id={id}
          onChange={onChange}
          placeholder={placeholder}
          data-xc="LabeledTextarea"
          ref={ref}
          value={value}
        />
      </LabeledFieldWrapper>
    );
  }
);

LabeledTextarea.propTypes = {
  backgroundColor: PropTypes.oneOf(['white, gray']),
  errorMessage: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  resizable: PropTypes.oneOf(['vertical, horizontal, both, none']),
  value: PropTypes.string.isRequired,
};

export default LabeledTextarea;
